import get from "lodash/get";
import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Row } from "reactstrap";
import { Exercise } from "./Exercise";
import VisualizerModel from "../../components/modals/VisualizerModel";

import {
  exerciseType,
} from "../../components/constants/constants";
import { ToastContainer } from "react-toastify";

let answers = [];

export const type = {
  Exercise: "Exercise",
  Assessment: "Assessment",
};

const ExerciseRunner = ({
  data,
  isReview,
  onUpdate,
  EndGptResponse,
  setExerciseData,
  setFormData,
  Qblinker,
  IsGenerating,
  ChatgptError,
}) => {
  const [visualizerModal, setVisualizerModal] = useState(false);
  const visualizerToggle = () => setVisualizerModal(!visualizerModal);
  const [isOpenAdditionalResourceModal, setOpenAdditionalResourceModal] =
    useState(false);

  const additionalResourceToggle = () =>
    setOpenAdditionalResourceModal(!isOpenAdditionalResourceModal);
  const [isStopTimer, setIsStopTimer] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [questions, setQuestions] = useState([]);
  const [timer, setTimer] = useState();
  
  useEffect(() => {
    setTimer(
      data.status === "New" || data.time_spent === null
        ? "00"
        : get(data, "time_spent")
    );
    setQuestions(get(data, "questions"));
  }, [data]);
  const [Createaudio, setCreateaudio] = useState(false);
  const GenerateAudioQuestions = () => {
    setFormData((formData) => ({
      ...formData,
      audio_text: data?.audio_text ? data?.audio_text: "",
      exercise_title: data?.prompt_content?.content ? data?.prompt_content?.content : "" 
    }));
    setExerciseData((ExerciseData) => ({
      ...ExerciseData,
      audio_creation: true,
    }));
    let form_submit = document.getElementById("SubmitForm");
    setTimeout(function () {
      form_submit.click();
    }, 100);
  };

  return (
    <div className="dashboard-wrapper">
      <div className="bg-lblue">
        <form>
          <div className={`g-0 row px-5 min-h-84`}>
            <div className={`sm-py-1 px-5`}>
              <div className="quiz-detail pt-4 pb-3 quiz-detail-width">
                <Exercise
                  visualizerToggle={visualizerToggle}
                  isReview={isReview}
                  data={data}
                  isStopTimer={isStopTimer}
                  setIsStopTimer={setIsStopTimer}
                  timer={timer}
                  isOpenAdditionalResourceModal={isOpenAdditionalResourceModal}
                  setOpenAdditionalResourceModal={
                    setOpenAdditionalResourceModal
                  }
                  additionalResourceToggle={additionalResourceToggle}
                  questions={questions}
                  currentPage={currentPage}
                  answers={answers}
                  setCurrentPage={setCurrentPage}
                  onUpdate={onUpdate}
                  EndGptResponse={EndGptResponse}
                  Qblinker={Qblinker}
                  IsGenerating={IsGenerating}
                  Createaudio={Createaudio}
                  ChatgptError={ChatgptError}
                />
                <ToastContainer />
                <>
                  <Row className={`page-break rounded-footer`}>
                  </Row>
                </>
              </div>
              {data.task_type === exerciseType.LISTENING_TASK && !Createaudio && !IsGenerating && (
                <div className="col-12 text-center">
                  <div className="col-12">
                      <button
                        type="button"
                        class="btn btn-darkblue px-3 rounded-5 fs-8"
                        onClick={()=> {
                          setCreateaudio(true);
                          GenerateAudioQuestions();
                        }}

                      >
                        <b>Create audio & questions</b>
                      </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </form>
        <VisualizerModel isOpen={visualizerModal} toggle={visualizerToggle} />
      </div>
    </div>
  );
};

export default ExerciseRunner;
